import React from 'react'
import './Moretext3.css';

const Moretext3 = () => {
  return (
    <div>
    <div className="section1100">
        <div className="container1100">
          <div className="content-section1100">
            <div className="title1100">
              <h1>Discharge</h1>
            </div>
            <div className="content1100">
              {/* <h3>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Excepturi quasi odio, numquam fugiat illum similique!</h3> */}
              {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt inventore vitae doloremque dolore ut iusto recusandae beatae esse mollitia voluptate optio atque totam autem non blanditiis, odit commodi ullam repellat.</p>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt inventore vitae doloremque dolore ut iusto recusandae beatae esse mollitia voluptate optio atque totam autem non blanditiis, odit commodi ullam repellat.</p>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt inventore vitae doloremque dolore ut iusto recusandae beatae esse mollitia voluptate optio atque totam autem non blanditiis, odit commodi ullam repellat.</p> */}
              {/* <div className="button">
                <a href="">Read More</a>
              </div> */}
            </div>
            <div className="social">
              {/* <a href=""><i className='fab fa-facebook-f'></i></a>
              <a href=""><i className='fab FaTwitter'></i></a>
              <a href=""><i className='fab fa-instagram'></i></a> */}
            </div>
          </div>
          {/* <div className="image-section">
            <img src="/images/6.jpg" alt="" />
          </div> */}
        </div>
      </div>
  </div>
  )
}

export default Moretext3
